import printComponent from './print_branch_coin.component';

let printModule = angular.module('branchCoinPullReportPrint', [
])
    .config(($stateProvider, $urlRouterProvider) => {
        "ngInject";

        $urlRouterProvider.otherwise('/branchManagement.bagouts');

        $stateProvider
            .state('branchCoinPullReportPrint', {
                url: '/print-branch-coin',
                component: 'branchCoinPullReportPrint',
                data: {
                    requireLogin: true,
                    requireACL: 'coin_pull_report.all'
                },
            })
    })

    .component('branchCoinPullReportPrint', printComponent)

    .name;

export default printModule;


// WEBPACK FOOTER //
// ./client/app/components/coin_pull_report/print_branch_coin/index.js